import { useState } from "react";
import Project from "../../models/project";
import { Panel, PanelBody, PanelHeader } from "../panel/panel";
import { useAppSelector } from "../../store/hooks";
import { selectLabels } from "../../store/labelsSlice";
import { Link } from "react-router-dom";

type GradeUnitSummaryProps = {
  project?: Project;
}

export default function GradeUnitSummary(props: GradeUnitSummaryProps) {
  const labels = useAppSelector(selectLabels);

  const { project } = props;

  const [isLoading, setIsLoading] = useState(false);

  const grades = [...new Set(project?.gradeUnits?.map(gu => gu.grade))];

  if ((grades?.length ?? 0) === 0) {
    return <></>;
  }

  return <Panel className="card border-0" isLoading={isLoading}>
    <PanelHeader>Grades &amp; Units</PanelHeader>
    <PanelBody className="card-body">
      <table className="table table-sm table-responsive table-hover">
        <thead>
          <tr>
            <th>Grade</th>
            <th>Unit(s)</th>
          </tr>
        </thead>
        <tbody>
          {grades.map((grade) => {
            const units = project?.gradeUnits?.filter(gu => gu.grade === grade);
            return <tr key={grade}>
              <td>
                <Link to={`./grade/${grade}`} className="btn btn-link">Grade {labels.grades[grade]}</Link>
              </td>
              <td>
                {units?.map((unit) => <span className="badge badge-primary bg-primary me-2">{unit.unit}</span>)}
              </td>
            </tr>;
          })}
        </tbody>
      </table>
    </PanelBody>
  </Panel>;
}
